export default "__VITE_ASSET__I$zALv_G__"